import type { PortalSubscription } from '@api/customer-portal-api';

// The subscription rewards banner (LAS-514). The backend picks the one subscription whose
// banner the customer sees and sets reward on it alone; the portal only displays it.

export interface RewardBanner {
  cycle: number;
  imageUrl: string;
}

// The banner to show, or null for none. Takes the first usable reward, so an older
// backend that sends several still shows a single banner.
export const rewardBannerOf = (
  subscriptions: Pick<PortalSubscription, 'reward'>[],
): RewardBanner | null => {
  for (const { reward } of subscriptions) {
    const imageUrl =
      typeof reward?.banner_image_url === 'string' ? reward.banner_image_url.trim() : '';
    if (reward && imageUrl) return { cycle: reward.cycle, imageUrl };
  }
  return null;
};
